import React, {forwardRef, useImperativeHandle} from 'react'
import PropTypes from 'prop-types'

import {Section} from "../../02-Molecules/Section/Section"
import {FormRadios} from "../../01-Atoms/FormRadios/FormRadios";
import {FormInput} from "../../01-Atoms/FormInput/FormInput";

/**
 * Primary UI component for user interaction
 */
export const SectionInMemory = forwardRef(({ collapsed, heading, headingLarge, required, sectionId, recap, staticText, tracking, trackingEvent, validationHash, values,  ...props }, ref) => {
  const isValid = () => true


  useImperativeHandle(ref, () => ({
    isValid: ()  => isValid(),
  }))

  /**
   * Handle any form changes.
   *
   * @param {string} name
   *   The name of the value that changed
   * @param {string} value
   *   The new value
   */
  const handlerInputChange = (name, value) => {
    props.onInputChange(name, value)
  }

  return (
    <Section tracking={tracking} trackEvent={trackingEvent} collapsed={collapsed} heading={heading} headingLarge={headingLarge} sectionId={sectionId} textBefore={staticText.in_memory.text_before} textAfter={staticText.in_memory.text_after}>
      <div>
        <FormRadios
          label={staticText.in_memory.target_options_heading}
          name={'in_memory_target'}
          options={[
            { value: 'pet_memory', label: staticText.in_memory.option_pet },
            { value: 'loved_one_memory', label: staticText.in_memory.option_loved_one },
            { value: 'not_in_memory', label: staticText.in_memory.option_not_in_memory }
          ]}
          required={required}
          onInputChange={handlerInputChange}
          value={values.in_memory_target}
          validationHash={validationHash}
        />

        {values.in_memory_target === 'pet_memory' &&
        <FormInput
          label={'Pet name'}
          value={values.pet_name}
          name={'pet_name'}
          type={'text'}
          required={false}
          onInputChange={handlerInputChange}
          validationHash={validationHash}
        />
        }

        {values.in_memory_target === 'loved_one_memory' &&
        <FormInput
          label={'Name of loved one'}
          value={values.loved_one_name}
          name={'loved_one_name'}
          type={'text'}
          required={false}
          onInputChange={handlerInputChange}
          validationHash={validationHash}
        />
        }

        {values.in_memory_target && values.in_memory_target !== 'not_in_memory' &&
          <FormRadios
            label={staticText.in_memory.donation_source_options_heading}
            name={'donation_source'}
            options={[
              {value: 'personal_donation', label: staticText.in_memory.option_personal_donation},
              {value: 'funeral_collection', label: staticText.in_memory.option_funeral_collection},
            ]}
            required={required}
            onInputChange={handlerInputChange}
            value={values.donation_source}
            validationHash={validationHash}
          />
          }
      </div>
    </Section>
  )
})

SectionInMemory.propTypes = {
  collapsed    : PropTypes.bool,
  required     : PropTypes.bool,
  heading      : PropTypes.string,
  headingLarge : PropTypes.bool,
  sectionId    : PropTypes.string,
  onInputChange: PropTypes.func,
  staticText   : PropTypes.shape({
    in_memory: PropTypes.shape({
      text_before                    : PropTypes.string,
      target_options_heading         : PropTypes.string,
      option_pet                     : PropTypes.string,
      option_loved_one               : PropTypes.string,
      option_not_in_memory           : PropTypes.string,
      donation_source_options_heading: PropTypes.string,
      option_personal_donation       : PropTypes.string,
      option_funeral_collection      : PropTypes.string,
      text_after                     : PropTypes.string,
    })
  }),
  tracking: PropTypes.shape({
    id  : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    type: PropTypes.oneOf(['entry', 'exit', 'entry_exit'])
  }),
  trackEvent: PropTypes.func,
  values: PropTypes.shape({
    target      : PropTypes.string,
    in_memory_target_other: PropTypes.string,
    donation_source : PropTypes.string,
    pet_name: PropTypes.string,
    loved_one_name: PropTypes.string,
  }),
  options: PropTypes.arrayOf(PropTypes.string),

  validationHash: PropTypes.string,
}

SectionInMemory.defaultProps = {
  collapsed: false,
  recap    : false,
  required : false
}

